import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedUser } from '@edx/frontend-platform/auth';

const isEnterpriseUser = () => {
  const authenticatedUser = getAuthenticatedUser();
  const userRoleNames = authenticatedUser && authenticatedUser.roles
    ? authenticatedUser.roles.map(role => role.split(':')[0]) : [];
  return userRoleNames.includes('enterprise_learner');
};

const hideCourseSuggestionsForEnterpriseLearners = (courseRecommendationsWidget) => {
  const modifiedWidget = { ...courseRecommendationsWidget };
  if (isEnterpriseUser()) {
    modifiedWidget.hidden = true;
  }
  return modifiedWidget;
};

const modifyViewCoursesForEnterpriseLearners = (viewCoursesLinkWidget) => {
  const modifiedWidget = { ...viewCoursesLinkWidget };
  if (isEnterpriseUser()) {
    modifiedWidget.content = { href: getConfig().ENTERPRISE_LEARNER_PORTAL_URL };
  }
  return modifiedWidget;
};

const modifyDashboardFootnoteForEnterpriseLearners = (footnoteLinkWidget) => {
  const modifiedWidget = { ...footnoteLinkWidget };
  if (isEnterpriseUser()) {
    modifiedWidget.content = { destination: getConfig().ENTERPRISE_LEARNER_PORTAL_URL };
  }
  return modifiedWidget;
};

export default hideCourseSuggestionsForEnterpriseLearners;

export {
  hideCourseSuggestionsForEnterpriseLearners,
  modifyViewCoursesForEnterpriseLearners,
  modifyDashboardFootnoteForEnterpriseLearners,
};
